import React, { useEffect, useState } from "react";
import {
  CheckBoxInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button.jsx";
import { getCurrentDate } from "../../utils/formatTime.js";
import Table from "../../components/common/table/Table.jsx";
import { useDispatch, useSelector } from "react-redux";
import { history } from "../../_helpers/history.js";
import {
  keywordAction,
  masterActions,
  authActions,
} from "../../_store/index.js";
import fileReplicate from "../../assets/replicate.svg";
import activeIcon from "../../assets/svg/approved.svg";
import inactiveIcon from "../../assets/svg/inactive-user.svg";
import CustomLoader from "./../../components/common/ui/Loader";
import CommonModal from "./../../components/common/ui/NotificationModal/CommonModal";
import { isAction } from "@reduxjs/toolkit";
import { showToastNotification } from "./../../components/common/ui/NotificationModal/ToastNotication";
import Facility from "./../Facility/Facility";
import ExcelExport from "../../components/common/ui/Export/ExcelExport.jsx";
import generateXlsx from "../../components/common/export/generateXlsx.js";
import { MenuItem, UserRoleType } from "../../_helpers/enumerator";
import Swal from "sweetalert2";
import MultiSelectDropdown from "../../components/common/ui/Inputs/MultiSelectDropdown.jsx";
import AddIcon from "../../assets/svg/btn_icons/create-btn-icon.svg";

function KeywordList() {
  const { Action, FilterType, podStatusOptions } = useSelector(
    (x) => x.dropdownOptions
  );

  const { facilityDropDown: facilitydata } = useSelector(
    (state) => state.master
  );
  const { commonFacilityCode: facilityCode } = useSelector(
    (state) => state.auth
  );
  let sorting = false;
  const isPageReloading = useSelector((state) => state.master?.isPageReload);
  const [showSearchFields, setShowSearchFields] = useState(false);
  const {
    searchKeyword,
    loadKeywordList,
    loadKeywordFullList: excelData,
    loading,
    keywordData: newData,
    facilityOpts,
  } = useSelector((x) => x.keyword);

  const { user } = useSelector((x) => x.auth);

  let keywordNewData = { ...newData };

  //Management User Access Permission selector
  const userAccessPermission = useSelector(
    (state) => state.auth.managementUserAccessPermission
  );
  // const [keywordData, setKeywordData] = useState({
  //   MessageKeyWord: "",
  //   FacilityID: facilityCode,
  //   WebUserSentAction: "",
  //   WebUserSentActionID: 3,
  //   InmateSentAction: "",
  //   InmateSentActionID: 3,
  //   KeyWordFilterType: "",
  //   KeyWordFilterTypeID: 2,
  //   ActiveStatus: 2,
  //   PageNo: 1,
  //   RowCountPerPage: 10,
  //   SortBy: "",
  // });

  const [isFacilitySelectAll, setIsFacilitySelectAll] = useState(false);

  const [replicate, setReplicate] = useState({
    MessageKeyWordID: null,
    CreatedBy: null,
    Typ_Keyword_FacilityDetails: [],
  });

  let param = { ...searchKeyword };

  // Hide or Show Add Keyword button
  const shouldShowBtnAdd =
    Array.isArray(userAccessPermission) && userAccessPermission.length > 0
      ? userAccessPermission.some(
        (item) =>
          item?.SubMenuName === "Add" && item?.SubMenuActiveStatus === 1
      )
      : true;

  // Enabled or Disabled modify Keyword option in grid
  const shouldEnableModifyOption =
    Array.isArray(userAccessPermission) && userAccessPermission.length > 0
      ? userAccessPermission.some(
        (item) =>
          item?.SubMenuName === "Modify" && item?.SubMenuActiveStatus === 1
      )
      : true;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
      })
    ).catch((error) => {
      console.error("Error loading facilities:", error);
      // Optionally handle the error here
    });

    setReplicate((prev) => ({
      ...prev,
      CreatedBy: user.ManagementUserID,
    }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
    // setKeywordData((prev) => ({
    //   ...prev,
    //   FacilityID: facilityCode,
    // }));
    dispatch(
      keywordAction.setSearchKeyword({
        ...searchKeyword,
        FacilityID: facilityCode,
      })
    );
    // dispatch(keywordAction.LoadKeywordList(keywordData));

    //to set createdBy
    keywordNewData.FacilityID = facilityCode;
    keywordNewData.CreatedBy = user.ManagementUserID;
    dispatch(keywordAction.setKeywordData(keywordNewData));
  }, [facilityCode]);

  useEffect(() => {
    if (facilityCode) {
      const param = { ...searchKeyword };
      param.FacilityID = facilityCode;
      dispatch(keywordAction.LoadKeywordList(param))
        .then((result) => {
          if (result?.payload?.DataList?.length === 0) {
            const searchParams = { ...searchKeyword };
            searchParams.PageNo = 1;
            searchParams.RowCountPerPage = 10;
            dispatch(keywordAction.setSearchKeyword(searchParams));
            dispatch(keywordAction.LoadKeywordList(searchParams));
          }
        })
        .catch((err) => { });
    }
  }, [
    facilityCode,
    searchKeyword?.PageNo,
    searchKeyword?.RowCountPerPage,
    isPageReloading,
  ]);

  //Get Management User Access Permission list
  useEffect(() => {
    dispatch(
      authActions.GetManagementUserAccessPermission({
        ManagementUserID: user.ManagementUserID,
        ManagementMenuID: MenuItem.KeywordsMenuItem,
      })
    );
  }, [dispatch]);

  const handleAddKeyword = () => {
    Swal.close();
    dispatch(
      authActions.GetManagementUserAccessPermission({
        ManagementUserID: user.ManagementUserID,
        ManagementMenuID: MenuItem.KeywordsMenuItem,
      })
    )
      .then((res) => {
        const shouldShowButtonAdd =
          Array.isArray(res?.payload) && res?.payload.length > 0
            ? res?.payload.some(
              (item) =>
                item?.SubMenuName === "Add" && item?.SubMenuActiveStatus === 1
            )
            : true;
        if (!shouldShowButtonAdd) {
          showToastNotification(
            "Add keyword option has been disabled by the admin.",
            "error"
          );
          return;
        }
        history.navigate("/Admin/KeywordList/AddOrEditKeyword", {
          state: { id: null },
        });
      })
      .catch((e) => { });
  };

  const handleClkKeywordInfo = (row) => {
    Swal.close();
    dispatch(
      authActions.GetManagementUserAccessPermission({
        ManagementUserID: user.ManagementUserID,
        ManagementMenuID: MenuItem.KeywordsMenuItem,
      })
    )
      .then((res) => {
        const shouldEnableModifyOptions =
          Array.isArray(res?.payload) && res?.payload.length > 0
            ? res?.payload.some(
              (item) =>
                item?.SubMenuName === "Modify" &&
                item?.SubMenuActiveStatus === 1
            )
            : true;
        if (!shouldEnableModifyOptions) {
          showToastNotification(
            "Modify option has been disabled by the admin.",
            "error"
          );
          return;
        }
        history.navigate("/Admin/KeywordList/AddOrEditKeyword", {
          state: { id: row.MessageKeywordID },
        });
      })
      .catch((e) => { });
  };

  //Column for Table
  const columns = [
    {
      name: "Keyword",
      selector: (row) => row.MessageKeyword,
      key: "MessageKeyWord",
      sortable: true,
      cell: (row) => (
        <div
          className={`${shouldEnableModifyOption ? "Common_Link_Style " : ""}`}
          onClick={() => shouldEnableModifyOption && handleClkKeywordInfo(row)}
        >
          {row.MessageKeyword}
        </div>
      ),
    },
    {
      name: "Web User Action",
      key: "WebUserSentAction",
      selector: (row) => row.WebUserSentAction,
      sortable: true,
    },
    {
      name: "Inmate Action",
      key: "InmateSentAction",
      selector: (row) => row.InmateSentAction,
      sortable: true,
    },
    {
      name: "Filter Type",
      key: "KeyWordFilterType",
      selector: (row) => row.KeyWordFilterType,
      sortable: true,
    },
    {
      width: "80px",
      name: "Status",
      key: "ActiveStatus",
      selector: (row) => row.ActiveStatus,
      cell: (row) => {
        return (
          <div className="d-flex flex-wrap h-100">
            <img
              src={row.ActiveStatus === "Active" ? activeIcon : inactiveIcon}
              alt={row.ActiveStatus === "Active" ? "Active" : "Inactive"}
              style={{ width: "20px", height: "20px" }} // Adjust icon size as needed
              title={row.ActiveStatus === "Active" ? "Active" : "Inactive"}
            />
          </div>
        );
      },
      sortable: true,
    },
    // Conditionally add the "Action" column based on UserRoleID
    ...(user.UserRoleID === UserRoleType.SuperAdmin
      ? [
        {
          width: "80px",
          name: "Action",
          cell: (row) => {
            return (
              <div className="d-flex flex-wrap justify-content-center align-items-center h-100">
                <img
                  src={fileReplicate}
                  alt={"Active User"}
                  style={{ width: "20px", height: "20px" }} // Adjust icon size as needed
                  data-bs-toggle="modal"
                  data-bs-target="#keyword-modal"
                  onClick={() => handleFacilityList(row)}
                  title="Replicate to All"
                />
              </div>
            );
          },
          // selector: (row) => row.ActiveStatus,
          sortable: false,
        },
      ]
      : []),
  ];

  const handleFacilityList = (row) => {
    setIsFacilitySelectAll(false);
    dispatch(keywordAction.LoadMessageKeyWordFacilityList(facilityCode));
    setReplicate((prev) => ({
      ...prev,
      MessageKeyWordID: row.MessageKeywordID,
    }));
  };

  //Pagination
  const handlePageChange = (value) => {
    if (sorting) {
      sorting = false;
      return;
    }
    // setKeywordData((prev) => ({
    //   ...prev,
    //   PageNo: value,
    // }));
    if (isSorting) {
      isSorting = false;
      return;
    }
    dispatch(
      keywordAction.setSearchKeyword({
        ...searchKeyword,
        PageNo: value,
      })
    );
  };

  const handleRowPerPage = (value) => {
    // setKeywordData((prev) => ({
    //   ...prev,
    //   RowCountPerPage: value,
    // }));
    dispatch(
      keywordAction.setSearchKeyword({
        ...searchKeyword,
        RowCountPerPage: value,
        PageNo: 1,
      })
    );
  };

  const handleChange = (e) => {
    const { value, name } = e.target;

    param[name] = value;

    dispatch(keywordAction.setSearchKeyword(param));
    // setKeywordData(param);
  };

  const handleMultiSelectChange = (selectedOptions, name) => {
    if (Array.isArray(selectedOptions)) {
      setReplicate({
        ...replicate,
        Typ_Keyword_FacilityDetails: selectedOptions.map((option) => ({
          FacilityID: option?.FacilityID,
          action: 1,
          Facilitycode: option?.Facilitycode,
        })),
      });
    } else {
      setReplicate({ ...replicate, Typ_Keyword_FacilityDetails: [] });
    }
  };

  const handleSelectChange = (Selectedoption, name) => {
    switch (name) {
      case "WebUserSentAction":
        param.WebUserSentAction =
          Selectedoption?.label && Selectedoption.label !== "All"
            ? Selectedoption.label
            : "";
        param.WebUserSentActionID = Selectedoption?.value ?? 3;
        break;
      case "InmateSentAction":
        param.InmateSentAction =
          Selectedoption?.label && Selectedoption.label !== "All"
            ? Selectedoption.label
            : "";
        param.InmateSentActionID = Selectedoption?.value ?? 3;
        break;
      case "KeyWordFilterType":
        param.KeyWordFilterType =
          Selectedoption?.label && Selectedoption.label !== "All"
            ? Selectedoption.label
            : "";
        param.KeyWordFilterTypeID = Selectedoption?.value ?? 2;
        break;
      case "ActiveStatus":
        param.ActiveStatus = isNaN(parseInt(Selectedoption))
          ? 2
          : parseInt(Selectedoption);

        break;
      default:
        break;
    }
    dispatch(
      keywordAction.setSearchKeyword({
        ...param,
        PageNo: 1,
        RowCountPerPage: 10,
      })
    );
    // setKeywordData(param);
    dispatch(
      keywordAction.LoadKeywordList({
        ...param,
        PageNo: 1,
        RowCountPerPage: 10,
      })
    );
  };

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(
      keywordAction.setSearchKeyword({
        ...param,
        PageNo: 1,
        RowCountPerPage: 10,
      })
    );
    dispatch(
      keywordAction.LoadKeywordList({
        ...param,
        PageNo: 1,
        RowCountPerPage: 10,
      })
    );
  };

  const handleReset = () => {
    let param = {
      MessageKeyWord: "",
      FacilityID: facilityCode,
      WebUserSentAction: "-- ALL --",
      WebUserSentActionID: 3,
      InmateSentAction: "-- ALL --",
      InmateSentActionID: 3,
      KeyWordFilterType: "-- ALL --",
      KeyWordFilterTypeID: 2,
      ActiveStatus: 2,
      PageNo: 1,
      RowCountPerPage: 10,
      SortBy: "",
    };
    // setKeywordData(param);
    dispatch(keywordAction.setSearchKeyword(param));
    dispatch(keywordAction.LoadKeywordList(param));
  };

  const handleSelectFacility = (e, index, FacilityID) => {
    const { name, checked } = e.target;

    if (name === "FacilitySelectAll") {
      // Update the FacilityList to mark all as active/inactive based on 'checked'
      const updatedFacilityList = facilityOpts?.data?.map((obj, i) => {
        return { ...obj, isActive: checked };
      });
      setIsFacilitySelectAll(checked); // Update the 'select all' checkbox state
      dispatch(
        keywordAction.setfacilityOpts({
          ...facilityOpts, // Spread the existing facilityOpts object
          data: [
            ...updatedFacilityList, // Add the updated facility list
          ],
        })
      );

      // Create the replicate array based on the updated FacilityList
      const replicate = checked
        ? facilityOpts?.data?.map((obj, i) => {
          return { FacilityID: obj.FacilityID, Action: 1 };
        })
        : [];

      // Update the 'Replicate' state with the new array
      setReplicate((prev) => ({
        ...prev,
        Typ_Keyword_FacilityDetails: replicate, // Replace the existing array
      }));
    } else {
      // Update the specific facility item in FacilityList based on 'index'

      const updatedFacilityList = facilityOpts?.data?.map((obj, i) => {
        if (index === i) {
          return { ...obj, isActive: checked }; // Update the matched object
        }
        return obj; // Return the original object for unmatched cases
      });
      dispatch(
        keywordAction.setfacilityOpts({
          ...facilityOpts, // Spread the existing facilityOpts object
          data: [
            ...updatedFacilityList, // Add the updated facility list
          ],
        })
      );

      // Update the 'Replicate' state by appending the new value

      setReplicate((prev) => ({
        ...prev,
        Typ_Keyword_FacilityDetails: [
          ...prev.Typ_Keyword_FacilityDetails, // Preserve existing values
          {
            FacilityID: FacilityID, // Use the target value for FacilityID
            Action: 1,
          },
        ],
      }));
    }
  };

  const handleAddReplicate = () => {
    let check = replicate.Typ_Keyword_FacilityDetails?.length > 0;

    if (check) {
      dispatch(keywordAction.ReplicateKeyword(replicate)).then((res) => {
        if (res?.payload?.IsSucceed === 1) {
          showToastNotification(
            "Keyword information updated successfully",
            "success"
          );
          setReplicate((prev) => ({
            ...prev,
            Typ_Keyword_FacilityDetails: [],
          }));
        } else if (res?.payload?.IsSucceed === -2) {
          showToastNotification("Keyword already exists.", "error");
          setReplicate((prev) => ({
            ...prev,
            Typ_Keyword_FacilityDetails: [],
          }));
        }
      });
    }
  };

  //Excel

  useEffect(() => {
    if (excelData && excelData?.DataList?.length > 0) {
      const title = "Keywords_List";
      const generateExcelColumns = [
        "Keyword",
        "Web User Action",
        "Inmate Action",
        "Filter Type",
        "Status",
      ];

      const excelExportData = excelData?.DataList?.map((obj) => ({
        MessageKeyword: obj.MessageKeyword,
        WebUserSentAction: obj.WebUserSentAction,
        InmateSentAction: obj.InmateSentAction,
        KeyWordFilterType: obj.KeyWordFilterType,
        ActiveStatus: obj.ActiveStatus,
      }));

      // // Generate the Excel file with the transformed data

      try {
        generateXlsx(excelExportData, generateExcelColumns, title);
        dispatch(keywordAction.clearexcelData());
      } catch (error) { }
    }
  }, [excelData]);

  const handleClickExcel = () => {
    let updatedParam = {
      ...searchKeyword,
      PageNo: 1,
      RowCountPerPage: loadKeywordList.TotalRecordCount,
      exportExcel: true,
    };

    dispatch(keywordAction.LoadKeywordList(updatedParam));
  };

  let isSorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...searchKeyword };
    const newSortOrder = search.SortBy.includes(column.key)
      ? search.SortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortBy = `${column.key} ${newSortOrder}`;
    // search.FacilityID = facilityCode;
    dispatch(keywordAction.setSearchKeyword(search));
    dispatch(
      keywordAction.LoadKeywordList({
        ...searchKeyword,
        FacilityID: facilityCode,
        SortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  if (loading) {
    return <CustomLoader />;
  }

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="InmateAction"
                label="Inmate Action"
                options={Action}
                value={searchKeyword?.InmateSentActionID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "InmateSentAction")
                }
                isMulti={false}
                isClearable={searchKeyword?.InmateSentActionID !== 3}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="MessageKeyWord"
                label="Keyword"
                value={searchKeyword?.MessageKeyWord}
                handleChange={(e) => handleChange(e)}
                placeholder="Enter Keyword"
                maxLength={18}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="FilterType"
                label="Filter Type"
                options={FilterType}
                value={searchKeyword?.KeyWordFilterTypeID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "KeyWordFilterType")
                }
                isMulti={false}
                isClearable={searchKeyword?.KeyWordFilterTypeID !== 2}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="WebUserAction"
                label="Web User Action"
                options={Action}
                value={searchKeyword?.WebUserSentActionID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "WebUserSentAction")
                }
                isMulti={false}
                isClearable={searchKeyword?.WebUserSentActionID !== 3}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="Status"
                label="Status"
                options={podStatusOptions}
                value={searchKeyword?.ActiveStatus}
                handleChange={(e) =>
                  handleSelectChange(e?.value, "ActiveStatus")
                }
                isMulti={false}
                isClearable={searchKeyword?.ActiveStatus !== 2}
              />
            </div>
          </div>
        </div>

        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            className="me-2"
            label="Search"
            type="submit"
            status="primary"
            icon={"search"}
            onClick={handleSearch}
          />
          <Button
            className="me-2"
            label="Reset"
            type="button"
            icon={"fa-solid fa-rotate-right"}
            status="secondary"
            onClick={handleReset}
          />
        </div>
      </form>
    );
  };

  return (
    <div>
      {facilityCode ? (
        <>
          <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
            <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
              <div className=" d-block d-md-none">
                <div
                  className=" d-flex align-items-center justify-content-between"
                  style={{ background: "transparent", cursor: "pointer" }}
                  onClick={toggleInformation}
                >
                  <h2 className="form_title_uppercase text-color">
                    Keyword SEARCH
                  </h2>
                  <i
                    id="itagInformation"
                    className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                      }`}
                    style={{ fontSize: "20px" }}
                  ></i>
                </div>
              </div>
              {/* Mobile only (Below md breakpoint) */}
              <div className="d-block d-md-none mt-2">
                {showSearchFields && renderSearch()}
              </div>

              {/* Web only (Desktop and above) */}
              <div className="mb-3 d-none d-md-block">
                <h2 className="form_title_uppercase text-color">
                  Keyword SEARCH
                </h2>
              </div>
              {/* Web only (Desktop and above) */}
              <div className="d-none d-md-block">{renderSearch()}</div>
            </div>
            <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
              <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 resp-space">
                <h2 className="form_title_uppercase text-color">
                  Keywords LIST
                </h2>
                <div className="d-flex flex-wrap gap-3 align-items-center">
                  {shouldShowBtnAdd && (
                    <Button
                      variant="success"
                      className="me-2"
                      label="Add Keyword"
                      type="button"
                      // icon={"circle-plus"}
                      imgsrc={AddIcon}
                      status="btn-label"
                      onClick={handleAddKeyword}
                    />
                  )}
                  {loadKeywordList?.DataList?.length > 0 && (
                    <ExcelExport handleExcelExport={handleClickExcel} />
                  )}
                </div>
              </div>

              <Table
                columns={columns}
                data={loadKeywordList.DataList}
                pagination={true}
                onChangePage={(e) => handlePageChange(e)} // Call API when page changes
                onChangeRowsPerPage={(e) => handleRowPerPage(e)}
                totalRowCount={loadKeywordList?.TotalRecordCount}
                currentPage={searchKeyword?.PageNo}
                paginationPerPage={searchKeyword?.RowCountPerPage}
                onSort={handleSort}
                serverSideSort
                sortColumn={searchKeyword?.SortBy.split(" ")[0]}
                sortDirection={searchKeyword?.SortBy.split(" ")[1]}
              />
            </div>
          </div>

          <div className="Replicate Keyword">
            <CommonModal
              modalId="keyword-modal"
              title="Replicate Keyword"
              loader={facilityOpts?.loading}
              bodyContent={
                <div
                  style={{ minHeight: "400px", height: "400px" }}
                  className="shadow-sm p-3 rounded overflow-auto"
                >
                  <MultiSelectDropdown
                    options={facilityOpts?.data}
                    displayValue="Facilitycode"
                    handleChange={(selectedOption) =>
                      handleMultiSelectChange(selectedOption, "Accessible Menu")
                    }
                    placeholder="Choose Facility"
                    label={"Choose Facility"}
                  />
                  {/* <div
                    className="m-3 shadow p-3 rounded overflow-auto"
                    style={{ height: "85%" }}
                  >
                    <CheckBoxInput
                      label="Select / Unselect All"
                      name="FacilitySelectAll"
                      id="FacilitySelectAll"
                      // disabled={!facilityInformationData?.IsFormReqAccess}
                      handleClick={handleSelectFacility}
                      checked={isFacilitySelectAll}
                    />
                    {facilityOpts?.data?.map((form, i) => {
                      return (
                        <div key={i}>
                          <CheckBoxInput
                            label={form?.Facilitycode}
                            name={form?.Facilitycode}
                            id={form?.Facilitycode}
                            value={form?.Facilitycode}
                            // disabled={!facilityInformationData?.IsFormReqAccess}
                            handleClick={(e) =>
                              handleSelectFacility(e, i, form.FacilityID)
                            }
                            checked={form?.["isActive"] || isFacilitySelectAll}
                          />
                        </div>
                      );
                    })}
                  </div> */}
                </div>
              }
              footerContent={
                <div className="mb-4 ">
                  <button
                    className="btn button-success me-3"
                    data-bs-dismiss="modal"
                    onClick={handleAddReplicate}
                    disabled={
                      replicate.Typ_Keyword_FacilityDetails?.length === 0
                    }
                  >
                    Submit
                  </button>
                  <button
                    className="btn button-primary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              }
            />
          </div>
        </>
      ) : (
        <h4 className="facility-card">Select a Facility Code from the list</h4>
      )}
    </div>
  );
}

export default React.memo(KeywordList);
